import type { CollectionsApi } from '@wix/wix-code-collections-api'
import { updateField, updateSchema } from '@wix/wix-code-collections-api'
import { buildUrl, getCollection } from '@wix/wix-data-client-common'
import type { PatternDefinition } from '@wix/wix-data-client-common-standalone'
import { get } from 'lodash'

export const updatePageLinkFieldTitle = async ({
  routerPrefix,
  pattern,
  patternDefinition,
  pageTitle,
  collectionsApi,
}: {
  routerPrefix: string
  pattern: string
  patternDefinition: PatternDefinition
  pageTitle: string
  collectionsApi: CollectionsApi
}) => {
  const routerCollectionId = getCollection(patternDefinition)

  if (!routerCollectionId) {
    return
  }

  const { fields } = await collectionsApi.get(routerCollectionId)

  const pageRoutingUrl = buildUrl(routerPrefix, pattern)

  const fieldEntry = Object.entries(fields).find(
    ([_, value]) =>
      get(value, 'calculator.config.pattern') === `/${pageRoutingUrl}`,
  )

  if (!fieldEntry?.[0]) {
    return
  }

  await collectionsApi.execute(
    updateSchema(
      routerCollectionId,
      updateField(fieldEntry[0], {
        displayName: pageTitle,
      }),
    ),
  )
}
